/**
 * @file Abstract class for input with a dropdown
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { InputBase } from '../input-base/input-base';
/**
 * Class for the dropdown input component
 */
var DropdownInput = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownInput, _super);
    function DropdownInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.open = false;
        return _this;
    }
    /**
     * An outside click event
     */
    DropdownInput.prototype.clickOutside = function (e) {
        if (this.isOpen()) {
            this.setClose();
        }
    };
    /**
     * Returns whether the dropdown is open
     * @returns Returns if dropwn is open
     */
    DropdownInput.prototype.isOpen = function () {
        return (this.open === true);
    };
    /**
     * Returns whether the dropdown is closed
     * @returns Returns if dropwn is closed
     */
    DropdownInput.prototype.isClosed = function () {
        return (this.open === false);
    };
    /**
     * Used to open the dropdown and inform others about opening an interface element
     */
    DropdownInput.prototype.setOpen = function () {
        // Open dropdown
        this.open = true;
        this.dropDownOpened();
    };
    /**
     * Used to close the dropdown
     */
    DropdownInput.prototype.setClose = function () {
        // Close dropdown
        this.open = false;
    };
    /**
     * Toggle between the open en closed state of the dropdown
     */
    DropdownInput.prototype.toggle = function () {
        // Toggle between open en close
        if (this.isOpen()) {
            this.setClose();
        }
        else {
            this.setOpen();
        }
    };
    /**
     * Close the dropdown if current interface element is not active
     */
    DropdownInput.prototype.closeIfNotLastOpenComponent = function (element) {
        if (this.open && this !== element) {
            this.setClose();
        }
    };
    /**
     * Method that is called after setOpen is called, can be overridden
     *
     */
    DropdownInput.prototype.dropDownOpened = function () {
    };
    return DropdownInput;
}(InputBase));
export { DropdownInput };
